import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowUpRightIcon } from '../assets/icons/Icons';
import { disorders } from '../data/disorders';
import '../styles/articles.css';

const ArticlesGuides = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  return (
    <>
      <Navbar />
      <div className="articles-page">
        <div className="container">

          <div className="articles-header">
            <span className="section-tag">Articles &amp; guides</span>
            <h1>Understanding mental health, one condition at a time.</h1>
            <p>
              Plain-language information on common psychiatric conditions — how they
              present, how they're diagnosed, and when professional support helps most.
            </p>
          </div>

          <div className="articles-hub-grid">
            {disorders.map((d) => (
              <Link
                key={d.slug}
                to={`/resources/articles/${d.slug}`}
                className="disorder-card"
              >
                <div className="disorder-card-body">
                  <span className="disorder-card-tag">{d.fullName}</span>
                  <h2>{d.title}</h2>
                  <p>{d.summary}</p>
                </div>
                <div className="disorder-card-foot">
                  <span>Read article</span>
                  <ArrowUpRightIcon size={16} />
                </div>
              </Link>
            ))}
          </div>

          <div className="articles-disclaimer">
            <p>
              <strong>Educational use only.</strong> Information in this library is intended
              for general awareness and does not replace a professional clinical evaluation.
              If you or someone you know is struggling, please consider speaking with a
              qualified mental health professional.
            </p>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default ArticlesGuides;
